import URLResolver from './url-resolver';
import JSONFileHandler from './json-file-handler'
import $ from 'npm-zepto';

class WSO2Connect {

	static httpGet(url, authHeader, data) {
			return new Promise(function(resolve, reject) {
				$.ajax({
				type: 'POST',
				url: url,
				headers: {
				          'Accept': 'application/json',
				          'Content-Type': 'application/json',
				          'Authorization-Token' : authHeader
				        },
				dataType: 'json',
				contentType: 'application/json',
				data: JSON.stringify(data),
				success: function(data) {
					resolve(data);
				},
				error: function (request, status, error) {
        			var searchData=[];
		         	var json_obj = {};
	              	json_obj['statusCode']='401';
	              	searchData.push(json_obj);
	              	resolve(searchData);
    			}
				});
			});
	    }

	static getJsonData(type,paramsMap){
		var jsonData =[];
		try{
			if(URLResolver.getCurrentEnvironment()=='static')
			{
				jsonData= JSONFileHandler.getJsonFile(type);
				return jsonData;
			} else {
				let remoteUrl=URLResolver.getRemoteURL();
				switch (type) {
				    case 'recent':
				    remoteUrl=remoteUrl+'/position-search/1.0/get-recent-search';
				    	 break;
				    case 'position':
				     remoteUrl=remoteUrl+'/position-search/1.0/search-position';
				    	 break;
				    case 'save':
				     remoteUrl=remoteUrl+'/position-search/1.0/save-recent-search';
				    	 break;
				    default:
				    	remoteUrl='';
		 			}
		 		//let updatedUrl=	URLResolver.getUpdatedURLwithParams(remoteUrl,paramsMap);
		 		let data =	URLResolver.getUpdatedURLwithParams(remoteUrl,paramsMap);
		 		jsonData=WSO2Connect.httpGet(remoteUrl, paramsMap.get('authHeader'), data);
		 	}

		} catch (ex) {
	         console.log('error at muster in wso2-connect and error is  ',ex);
	           }
		return jsonData;
	}

	static getExcelStubData(type){
		var excelJsonData =[];
		try {
				if(URLResolver.getCurrentEnvironment()=='static') {
					excelJsonData = JSONFileHandler.getJsonFile(type);
				}
		} catch (ex) {
	       console.log('error in connection',ex);
	  	}
		return excelJsonData;
	}
}

export default WSO2Connect;
